import { render } from "./ImageGraph.vue?vue&type=template&id=720038d2&scoped=true"
import script from "./ImageGraph.vue?vue&type=script&lang=js"
export * from "./ImageGraph.vue?vue&type=script&lang=js"

import "./ImageGraph.vue?vue&type=style&index=0&id=720038d2&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720038d2"]])

export default __exports__